export const getCurrencyByCountry = (country: string) => {
    switch (country.toUpperCase()) {
      case 'SE':
        return 'SEK';
      case 'NO':
        return 'NOK';
      case 'DK':
        return 'DKK';
      case 'FI':
        return 'EUR';
      default:
        return 'EUR';
    }
  }

  